import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { APP_VERSION } from "@fuse/services/config/config.constants";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  private _httpClient = inject(HttpClient);

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get translation
   *
   * @param lang
   */
  getTranslation(lang: string): Observable<Translation> {
    return this._httpClient.get<Translation>(`./assets/i18n/${lang}.json?v=${APP_VERSION}`);
  }
}
